import React from 'react';

const ChildTask = ({ item, moveChildTask, highlightClass }) => {
    const isUnread = item?.Email?.messageRead === 'unread' || item?.subEmail?.messageRead === 'unread';
    const displayTitle = item?.title || item?.subject || item?.Email?.subject || "(No Title)";

    return (
        <div className="child-task-row">
            <div className="grid-disp">
                <h3
                    className={`title-box child-task-title ${isUnread ? 'font-bold' : highlightClass} ${!item?.title && !item?.subject && !item?.Email?.subject ? 'child-task-title--empty' : ''}`}
                    title={displayTitle}
                >
                    {displayTitle}
                </h3>

                <div className="date-align">
                    {isUnread && <div className="unread-red-dot"></div>}
                    <span data-no-popup className="child-task-icon" title="Remove">
                        <img alt="Remove" src="assets/popout.svg" onClick={() => moveChildTask(item, '', true)} />
                    </span>
                </div>
            </div>
        </div>
    );
};

export default ChildTask;
